import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import Model from "@ckeditor/ckeditor5-ui/src/model"
import { createDropdown } from "@ckeditor/ckeditor5-ui/src/dropdown/utils"
import SplitButtonView from "@ckeditor/ckeditor5-ui/src/dropdown/button/splitbuttonview"
import Collection from "@ckeditor/ckeditor5-utils/src/collection"
import api from "../../honcierge-api"
import Vue from "vue"
import store from "../../store"

import OptionListItemView from "../customcomponents/optionlistitemview"
import SelectView from "./selectview"
import View from "@ckeditor/ckeditor5-ui/src/view"

export default class AppAffiliateTemplateUI extends Plugin {
  enableUI() {
    const role = store.state.adminUser.role
    return role === "editor" || role === "administrator"
  }

  // データが沢山あって、シーケンシャルに初期化するとパフォーマンスがでないので
  // 後からアプリアフィリエイトテンプレートを入れる
  init() {
    const editor = this.editor

    const itemDefinitions = new Collection() // アプリアフィリエイトテンプレートを入れる
    let dropdownView

    if (this.enableUI()) {
      editor.ui.componentFactory.add("appAffiliateTemplate", (locale) => {
        dropdownView = createDropdown(locale, SplitButtonView)
        dropdownView.buttonView.set({
          value: {},
          isOn: true,
          withText: true,
          label: "アプリアフィリエイトテンプレート",
        })
        dropdownView.buttonView.on("execute", () => {
          // コマンド実行
          editor.execute(
            "insertAppAffiliateTemplate",
            dropdownView.buttonView.value
          )
          editor.editing.view.focus()
        })

        return dropdownView
      })

      //
      // 後からアプリアフィリエイトテンプレートマスタデータを入れる
      //
      this.listenTo(this.editor.data, "ready", async () => {
        let templates = []
        try {
          const response = await api.getAppAffiliateTemplates(
            "",
            "",
            "all",
            null,
            "id",
            true,
            1,
            10000000,
            ["id", "name"]
          )
          templates = response.data.appAffiliateTemplates
          store.dispatch("master/updateAppAffiliateTemplates", templates)
          templates.forEach((template) => {
            itemDefinitions.add(
              new Model({
                appAffiliateTemplateId: template.id,
                appAffiliateTemplateName: template.name,
                withText: true,
              })
            )
          })
          this.addCustomListToDropdown(dropdownView, itemDefinitions)
        } catch {
          Vue.toasted.error(
            "アプリアフィリエイトテンプレートマスタの取得に失敗しました"
          )
        }
      })
    }
  }

  addCustomListToDropdown(dropdownView, items) {
    const locale = dropdownView.locale
    const selectView = (dropdownView.listView = new SelectView(locale))

    // listView(selectタグ)のプロパティとdropdown.buttonViewのプロパティをbind
    // これは選択されたアフィリエイトテンプレートをbindするためのもの
    dropdownView.buttonView.bind("value").to(selectView)

    selectView.items.bindTo(items).using((model) => {
      const optionView = new OptionListItemView(locale)
      const itemView = this._createItemView(
        model.appAffiliateTemplateId,
        model.appAffiliateTemplateName
      )
      optionView.children.add(itemView)

      return optionView
    })

    dropdownView.panelView.children.add(selectView)
    selectView.initFirst() // 初期化時に最初の要素を設定する
  }

  _createItemView(appAffiliateTemplateId, appAffiliateTemplateName) {
    const view = new View()

    view.set({ label: appAffiliateTemplateName })

    view.setTemplate({
      tag: "div",
      attributes: {
        "app-affiliate-template-id": appAffiliateTemplateId,
        "app-affiliate-template-name": appAffiliateTemplateName,
      },
      children: [
        {
          text: view.bindTemplate.to("label"), // このlabelはメソッドの内で定義済みのobservableな'label'を指定
        },
      ],
    })

    return view
  }
}
